import "core-js/modules/es.array.includes.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-779ff16d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "memory-shell",
  "aria-labelledby": "image-memory-title"
};
const _hoisted_2 = {
  class: "memory-header"
};
const _hoisted_3 = {
  class: "eyebrow"
};
const _hoisted_4 = {
  id: "image-memory-title"
};
const _hoisted_5 = {
  class: "level-badge"
};
const _hoisted_6 = {
  class: "display-panel"
};
const _hoisted_7 = {
  class: "instruction"
};
const _hoisted_8 = {
  class: "icon-grid display-grid",
  "aria-label": "九个待记忆图形"
};
const _hoisted_9 = {
  key: 0,
  class: "answer-panel"
};
const _hoisted_10 = {
  class: "answer-heading"
};
const _hoisted_11 = ["aria-label"];
const _hoisted_12 = {
  class: "slot-index"
};
const _hoisted_13 = ["disabled", "aria-label", "onClick"];
const _hoisted_14 = {
  key: 1,
  class: "review-result"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SequenceLine = _resolveComponent("SequenceLine");
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_3, "图形记忆力 · 第 " + _toDisplayString($props.data.questionIndex + 1) + " 题", 1), _createElementVNode("h2", _hoisted_4, _toDisplayString($options.phaseTitle), 1)]), _createElementVNode("div", _hoisted_5, "难度 " + _toDisplayString($props.data.level) + " · 记忆 " + _toDisplayString($props.data.memoryCount) + " 个", 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString($options.instruction), 1), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.displayIds, assetId => {
    return _openBlock(), _createElementBlock("div", {
      key: assetId,
      class: _normalizeClass(["icon-tile display-tile", {
        active: $data.activeAssetId === assetId
      }])
    }, [(_openBlock(), _createBlock(_resolveDynamicComponent($options.iconFor(assetId)), {
      "aria-hidden": "true"
    }))], 2);
  }), 128))])]), $data.phase === 'answering' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString($props.reviewMode ? '顺序回看' : '按闪烁顺序点击'), 1), !$props.reviewMode && $data.selectedIds.length ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    type: "button",
    class: "text-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.clearAnswer && $options.clearAnswer(...args))
  }, " 清空 ")) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "answer-slots",
    "aria-label": `已选择 ${$data.selectedIds.length} 个，共需选择 ${$props.data.memoryCount} 个`
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.memoryCount, index => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["answer-slot", {
        filled: $data.selectedIds[index - 1]
      }])
    }, [_createElementVNode("span", _hoisted_12, _toDisplayString(index), 1), $data.selectedIds[index - 1] ? (_openBlock(), _createBlock(_resolveDynamicComponent($options.iconFor($data.selectedIds[index - 1])), {
      key: 0,
      "aria-hidden": "true"
    })) : _createCommentVNode("", true)], 2);
  }), 128))], 8, _hoisted_11), !$props.reviewMode ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "icon-grid option-grid",
    style: _normalizeStyle({
      '--option-columns': Math.min($props.data.answerOptionIds.length, 5)
    }),
    "aria-label": "答题选项"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.answerOptionIds, assetId => {
    return _openBlock(), _createElementBlock("button", {
      key: assetId,
      type: "button",
      class: _normalizeClass(["icon-tile option-tile", {
        selected: $data.selectedIds.includes(assetId)
      }]),
      disabled: $data.selectedIds.includes(assetId) || $data.selectedIds.length >= $props.data.memoryCount,
      "aria-label": `选择图形 ${assetId}`,
      onClick: $event => $options.selectAsset(assetId)
    }, [(_openBlock(), _createBlock(_resolveDynamicComponent($options.iconFor(assetId)), {
      "aria-hidden": "true"
    }))], 10, _hoisted_13);
  }), 128))], 4)) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_SequenceLine, {
    label: "正确顺序",
    ids: $options.correctIds,
    "icon-for": $options.iconFor,
    tone: "correct"
  }, null, 8, ["ids", "icon-for"]), _createVNode(_component_SequenceLine, {
    label: "您的顺序",
    ids: $options.reviewIds,
    "icon-for": $options.iconFor,
    tone: $props.review?.result ? 'correct' : 'wrong'
  }, null, 8, ["ids", "icon-for", "tone"]), _createElementVNode("button", {
    type: "button",
    class: "replay-button",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.startPlayback && $options.startPlayback(...args))
  }, "重新播放")]))])) : _createCommentVNode("", true)]);
}